<template lang="pug">
  div
    button.change-button(
      :disabled="disabled || loading"
      @click="showModalParte = true"
      @hide="hideModal()"
    )
      b-spinner(v-if="loading" small)
      span {{ loading ? 'Procesando...' : 'Pedir cambio por espera de partes' }}
    //- MODAL EXCEPCION ESPERA DE PARTES
    SamtekModal(
      v-model="showModalParte" 
      title="Ingresar información de parte"
      @shown="onModalShown"
      @hide="onModalHide"
      confirmText="Guardar"
      @confirm="createExcepcionWaitingParts"
      :loading="loading"
    )
      b-col
        b-form-group(
          label-for= "input-comentario_solicitud"
          label="Comentario:")
          b-form-textarea(
            v-model="comentario_solicitud"
            placeholder="Ingrese su comentario"
            rows="3"
          )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionCambioEsperaDeParte',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  components: {
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  validations: {
    comentario_solicitud: { required },
  },
  data() {
    return {
      showModalParte: false,
      comentario_solicitud: '',
    }
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
  methods: {
    ...mapActions('Exceptions', ['createExcepcion']),
    ...mapActions('OTStore', ['getOT']),

    onModalShown() {
      // Evento cuando se muestra el modal
    },

    onModalHide() {
      // Evento cuando se oculta el modal
    },

    hideModal() {
      this.showModalParte = false
    },
    async createExcepcionWaitingParts() {
      if (this.$v.$invalid) {
        this.$bvToast.toast('Rellene todos los campos requeridos', {
          variant: 'danger',
        })
        return
      }

      try {
        await this.executeWithLoading(async () => {
          const form = {
            estado: 1,
            orden_trabajo: this.ot.ot,
            comentario_solicitud: this.comentario_solicitud
              ? this.comentario_solicitud
              : null,
            solicitado_por: this.user.id,
            tipo: 'Cambio en espera de parte',
          }
          const res = await this.createExcepcion(form)
          if (res.status === 200) {
            this.$bvToast.toast('Solicitud creada correctamente', {
              variant: 'success',
            })
            this.$emit('changed')
            await this.getOT(this.ot.ot)
            this.hideModal()
          } else {
            this.$bvToast.toast(`Error al crear excepción: ${res.data}`, {
              variant: 'danger',
            })
            this.hideModal()
          }
        })
      } catch (error) {
        console.error('Error al crear excepción espera de partes:', error)
        this.$bvToast.toast('Error al crear la solicitud', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
